<template>
    <div v-if="!isConsented()" class="comp-consent consent--must-consent bg-gray-800 " style="border-radius: 1.5rem; min-height: 200px;">
        <div class="p-4 w-full">
            <slot name="description"></slot>
        </div>
        <div class="flex justify-center items-center">
            <button class="btn btn-black mx-2" v-on:click.prevent="consent()">{{ __('consent.for-now') }}</button>
            <button class="btn btn-black mx-2" v-on:click.prevent="consent(true)">{{ __('consent.for-ever') }}</button>
        </div>
    </div>
    <div v-else>
        <slot></slot>
    </div>
</template>
<script>
import { __ } from '@/locale'

export default {
    emits: ['update:consented'],
    props: ['storeKey'],

    data() {
        return {
            consented: [],
            temporary: false,
            __,
        }
    },
    mounted() {
        let stored = localStorage.getItem(`rGMustConsent`)
        if(stored) this.consented = JSON.parse(stored);

        if(this.consented.includes(this.storeKey)) {
            this.$emit('update:consented', { detail: this.storeKey });
        }
    },

    methods: {
        isConsented() {
            return this.temporary || this.consented.includes(this.storeKey);
        },

        consent(forever = false) {
            if(!forever) {
                this.temporary = true;
                this.$emit('update:consented', { detail: this.storeKey });
                return;
            }

            this.consented.push(this.storeKey);
            this.updateLocalStore();
            this.$emit('update:consented', { detail: this.storeKey });
        },

        updateLocalStore() {
            localStorage.setItem('rGMustConsent', JSON.stringify(this.consented));
        },
    }
}
</script>
